import React from 'react'
import { ArrayInput, FormDataConsumer, SimpleFormIterator } from 'react-admin'
import ProfessionalsSelectionDetailsForm from 'resources/operations/events/eventsFormTabs/ProfessionaTab/ProfessionalsSelectionDetailsForm'
import { isProfessionalServiceObsolete } from 'resources/operations/events/utils'
import { ProfessionalSection } from 'services/api/entities/catalog/sections/professionalSections'
import { EnrichedProfessionalService } from 'services/api/entities/events/types/internal/services'
import { getById } from 'services/utils'
import { FormDataConsumerProps } from 'types/common'
import LocalizedSelectInput from 'ui-shared/LocalizedFields/LocalizedSelectInput'

type Props = {
  choices?: ProfessionalSection[]
}

const ProfessionalServiceSelectionInput: React.FC<Props> = ({
  choices = [],
  ...rest
}) => (
  <ArrayInput source={'professionals'}>
    <SimpleFormIterator disableReordering>
      <FormDataConsumer {...rest}>
        {({
          scopedFormData,
          getSource,
        }: FormDataConsumerProps<unknown, EnrichedProfessionalService>) => {
          const isObsolete = isProfessionalServiceObsolete(
            choices,
            scopedFormData
          )

          return (
            <>
              <LocalizedSelectInput
                {...rest}
                choices={choices}
                label="form.fields.professionalSections"
                source={getSource!('id')}
                forceDisabled={!!scopedFormData?.id || isObsolete}
              />
              {!!scopedFormData && (
                <ProfessionalsSelectionDetailsForm
                  scopedFormData={scopedFormData}
                  getSource={getSource}
                  selectedProduct={getById(choices, scopedFormData.id)}
                  isObsolete={isObsolete}
                />
              )}
            </>
          )
        }}
      </FormDataConsumer>
    </SimpleFormIterator>
  </ArrayInput>
)

export default ProfessionalServiceSelectionInput
